<h1>Login</h1>
<p>Welcome to the Hub! Enter your login information below.</p>
<div class="container">
	<div class="row my-2">
		<div class="col-12 col-md-6 col-lg-3">Username:</div>
		<div class="col-12 col-md-6 col-lg-3">
			<input type="text" [(ngModel)]="username" />
		</div>
	</div>
	<div class="row my-2">
		<div class="col-12 col-md-6 col-lg-3">Password:</div>
		<div class="col-12 col-md-6 col-lg-3">
			<input type="password" [(ngModel)]="password" />
		</div>
	</div>
	<div class="row my-2">
		<div class="col-12 col-md-6 offset-md-6 col-lg-3 offset-lg-3">
			<button class="btn btn-block btn-primary" (click)="login()">Login</button>
		</div>
	</div>
</div>
